/**
 * Phase 3 - Japanese translations module
 */
import enBase from './en.js';
import { translationsJa } from '../../utils/translations/translations.ja.js';
import { plansTranslationsJa } from '../../utils/translations/plans/plansTranslations.ja.js';

const merged = { ...enBase, ...translationsJa, ...plansTranslationsJa };
export default merged;
